<template>
  <div>

    <div v-loading.fullscreen.lock="fullScreenLoading"
         element-loading-text="Loading, please wait..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
    </div>

    <div class="block">
      <el-tree
        ref="tree"
        :data="structure"
        node-key="id"
        :highlight-current = "highlightCurrent"
        :default-expanded-keys="['0']"
        :show-checkbox = "showCheckbox"
        @node-click="nodeClick"
        :filter-node-method="filterNode"
        empty-text="Empty Content"
        :expand-on-click-node="false">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <el-tooltip :content="data[nodeName]" placement="top" :open-delay="500">
            <div class="black min-font cls-label">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
              <div v-if="splitTableName(data).isService== 2">
                <span
                  v-if="splitTableName(data)['description']&&splitTableName(data[nodeName].indexOf(splitTableName(data)['description'])) == -1">
                  {{'('+splitTableName(data)['description']+')'}}
                </span>
              </div>
            </div>
          </el-tooltip>
          <div v-if="showReadWrite" style="display: flex; align-items: center;">
            <template v-if="independent">
              <el-checkbox v-if="!node.data.isService" v-model="node.data.readChecked" :disabled="node.data.readDisabled" :indeterminate="node.data.readIndeterminate" label="Read" @change="readChangeForIndependent(node)"></el-checkbox>
              <el-checkbox v-if="!node.data.isService" v-model="node.data.writeChecked" :disabled="node.data.writeDisabled" :indeterminate="node.data.writeIndeterminate" label="Write" @change="writeChangeForIndependent(node)"></el-checkbox>
            </template>
            <template v-else>
              <el-checkbox v-model="node.data.readChecked" :disabled="node.data.readDisabled" :indeterminate="node.data.readIndeterminate" label="Read" @change="readChange(node)"></el-checkbox>
              <el-checkbox v-model="node.data.writeChecked" :disabled="node.data.writeDisabled" :indeterminate="node.data.writeIndeterminate" label="Write" @change="writeChange(node)"></el-checkbox>
            </template>
            <template v-if="type === 'configRoleFunction'">
              <el-select style="margin-left: 30px;" size="mini" :disabled="data[nodeName] === 'ROOT'" collapse-tags multiple clearable v-model="node.data.orgCodePaths" placeholder="Pleas Select ORG" @change="(val) => handleOrgCodePathsChange(val, node)">
                <el-option v-for="item in filterOrgList(node)" :key="item.orgodepath" :label="`${item.orgnamepath} (${item.role})`" :value="item.orgcodepath"></el-option>
              </el-select>
            </template>
            <!-- <el-popover placement="bottom-start" :disabled="!node.data.readChecked" trigger="hover" popper-class="cus-org-list-warp">
              <el-input
                slot="reference"
                size="mini"
                placeholder="Pleas Select ORG"
                suffix-icon="el-icon-arrow-down"
                readonly
                v-model="data[nodeName]"
                :disabled="!node.data.readChecked"
              ></el-input>
              <el-tree :data="structure" node-key="id" :props="propsKey" show-checkbox empty-text="Empty Content" @check-change="handleCheckChange"></el-tree>
            </el-popover> -->
          </div>
        </div>
      </el-tree>
    </div>

  </div>
</template>

<script>
  import util from '@/util/util.js'
  import { uniq } from 'lodash'

  export default {
    name: "data-source-structure",
    props: {
      showReadWrite: {
        type: Boolean,
        required: false,
        default: () => false
      },
      showCheckbox: {
        type: Boolean,
        required: false,
        default: () => false
      },
      defaultExpandAll: {
        type: Boolean,
        required: false,
        default: () => true
      },
      orgList: {
        type: Array,
        required: false,
        default: () => []
      },
      type: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        fullScreenLoading: false,
        confirmToRemovekeyDialogVisible: false,
        addFunctionDialogVisible:  false,
        editDataFacetKeyDialogVisible:false,
        confirmToRemoveKey: false,
        confirmToRemoveDialogVisible: false,
        dsDescription:'',
        newDfKey: '',
        highlightCurrent: false,
        test: false,
        nodeName: '',
        independent: false,
        readDisabled: false,
        writeDisabled: false,
        structure:[
          {
            id: '0',
            name: 'ROOT',
            orgCodePaths: [],
            readChecked: false,
            readIndeterminate: false,
            writeChecked: false,
            writeIndeterminate: false,
            children: []
          }
        ],
        propsKey: {
          label: 'functionName',
          children: 'children'
        },
      }
    },
    computed: {
      dfKey(){
        return '';
      }
    },
    created(){

    },
    methods:{
      filterOrgList(node){
        let options = [];
        let { data, parent } = node;
        if (!data.parentId) {
          options = this.orgList;
        } else {
          let { data: parentData } = parent;
          if (parentData.orgCodePaths && parentData.orgCodePaths.length) {
            let arr = this.orgList.filter(item => {
              return parentData.orgCodePaths.includes(item.orgcodepath);
            });
            options = uniq(arr);
          } else {
            let currentParent = parent;
            while (currentParent) {
              let { data: currentParentData } = currentParent;
              if (currentParentData.name === 'ROOT') {
                options = this.orgList;
                break;
              }
              if (currentParentData.orgCodePaths && currentParentData.orgCodePaths.length) {
                options = this.orgList.filter(item => {
                  return currentParentData.orgCodePaths.includes(item.orgcodepath);
                });
                break;
              }
              currentParent = currentParent.parent;
            }
          }
        }
        // 保存当前下拉选项
        node.data.options = options;
        return options;
      },
      handleOrgCodePathsChange(val, node){
        let { data, parent } = node;
        // 向下联动选择子级的orgCodePaths
        const updateChildren = (data) => {
          if (data.children && data.children.length) {
            data.children.forEach(child => {
              // 过滤不存在当前下拉选项的值
              let optionsArr = [];
              let arr = [];
              if (!child.orgCodePaths || !child.orgCodePaths.length) {
                arr = val;
              } else {
                // 取交集
                optionsArr = this.getFirstParentVal(child.parentId);
                arr = optionsArr.filter(v => child.orgCodePaths.includes(v));
              }
              child.orgCodePaths = arr;
              updateChildren(child);
            });
          }
        };
        updateChildren(data);

        // 向上联动选择父级的orgCodePaths
        // if (data.parentId) {
        //   let currentParent = parent;
        //   while (currentParent) {
        //     let { data: currentParentData } = currentParent;
        //     if (currentParentData.name === 'ROOT') {
        //       break;
        //     }
        //     currentParentData.orgCodePaths = uniq(currentParentData.orgCodePaths.concat(val));
        //     currentParent = currentParent.parent;
        //   }
        // }
      },
      // 获取父级节点的orgCodePaths
      getFirstParentVal(parentId) {
        const findNodeById = (nodes, id) => {
          for (const node of nodes) {
            if (node.id === id) {
              return node;
            }
            if (node.children && node.children.length) {
              const found = findNodeById(node.children, id);
              if (found) return found;
            }
          }
          return null;
        };

        const parentNode = findNodeById(this.structure, parentId);
        return parentNode ? parentNode.orgCodePaths || [] : [];
      },
      // handleCheckChange(data, checked, indeterminate) {
      //   console.log(data, checked, indeterminate);
      // },
      /**
       * 树的初始化函数
       * @param structure  树的标准结构
       * @param nodeName 显示叶子树形名
       * @param readCheckedProperties 表示是否可读的属性名
       * @param writeCheckedProperties  表示是否可写的属性名
       */
      init(structure, nodeName, readCheckedProperties, writeCheckedProperties){
        structure = util.deepClone(structure);

        try{
        this.nodeName = nodeName;
        let indeterminate = {
          readIndeterminateArray: [],
          writeIndeterminateArray: []
        };
        if(structure && structure.length){
          this.initReadWrite(structure, readCheckedProperties, writeCheckedProperties, indeterminate);
        }
        this.structure[0][nodeName] = 'ROOT';
        this.structure[0].children= [];
        this.structure[0].readIndeterminate = false;
        this.structure[0].writeIndeterminate = false;

        this.structure[0].children= structure;
        if(indeterminate.readIndeterminateArray.length || indeterminate.writeIndeterminateArray.length){
          this.handleIndeterminate(indeterminate);
        }
        //处理下半选的情况
        // this.initIndeterminate(structure[0], readCheckedProperties, writeCheckedProperties);
        }catch(e){
          console.info(e)
        }
      },
      initIndependent(structure, nodeName, readCheckedProperties, writeCheckedProperties){
        structure = util.deepClone(structure);

        this.independent = true;
        try{
          this.nodeName = nodeName;
          let indeterminate = {
            readIndeterminateArray: [],
            writeIndeterminateArray: []
          };
          if(structure && structure.length){
            this.initReadWrite(structure, readCheckedProperties, writeCheckedProperties, indeterminate);
          }
          // this.structure[0][nodeName] = 'ROOT';
          // this.structure[0].children= [];
          // this.structure[0].readIndeterminate = false;
          // this.structure[0].writeIndeterminate = false;

          this.structure = structure;
          // if(indeterminate.readIndeterminateArray.length || indeterminate.writeIndeterminateArray.length){
          //   this.handleIndeterminate(indeterminate);
          // }
          //处理下半选的情况
          // this.initIndeterminate(structure[0], readCheckedProperties, writeCheckedProperties);
        }catch(e){
          console.info(e)
        }
      },
      handleIndeterminate(indeterminate){
        if(indeterminate.readIndeterminateArray.length){
          this.handleIndeterminateCheckbox(indeterminate.readIndeterminateArray, 'read');
        }
        if(indeterminate.writeIndeterminateArray.length){
          this.handleIndeterminateCheckbox(indeterminate.writeIndeterminateArray, 'write');
        }
      },
      handleIndeterminateCheckbox(indeterminateArray, propertyPrefix){
        Array.prototype.remove = function(val) {
          let index = this.indexOf(val);
          if (index > -1) {
            this.splice(index, 1);
          }
        };
        indeterminateArray.forEach( nodeKey => {
          let nodeData = this.getNodeData(this.structure, nodeKey);
          if(nodeData && !nodeData[propertyPrefix + 'Checked']){
            nodeData[propertyPrefix + 'Indeterminate'] = true;
            //判断是否还有父级
            let parentId = nodeData.parentId;
            if(parentId){
              if(!this.inArray(indeterminateArray, parentId)){
                indeterminateArray.push(parentId);
              }
            }
            indeterminateArray.remove(nodeKey);
          }else{
            indeterminateArray.remove(nodeKey);
          }
        });
        if(indeterminateArray && indeterminateArray.length){
          this.handleIndeterminateCheckbox(indeterminateArray, propertyPrefix);
        }
      },
      getNodeData(node, nodeKey){
        for(let i = 0; i< node.length; i ++){
          let nodeData = node[i];
          if (nodeData.id === nodeKey) {
            return nodeData;
          }
          if (nodeData.children && nodeData.children.length) {
            return this.getNodeData(nodeData.children, nodeKey);
          }
        }
      },
      initReadWrite(structure, readCheckedProperties, writeCheckedProperties, indeterminate){
        structure.forEach( structureChild => {
          let parentId = structureChild.parentId ?  structureChild.parentId : '0';
          if(structureChild[readCheckedProperties]){
            structureChild.readChecked = true;
            if(!this.inArray(indeterminate.readIndeterminateArray, parentId)){
              indeterminate.readIndeterminateArray.push(parentId);
            }
          }else{
            structureChild.readChecked = false;
          }
          structureChild.readIndeterminate = false;
          structureChild.writeIndeterminate = false;

          if(structureChild[writeCheckedProperties]){
            structureChild.writeChecked = true;
            if(!this.inArray(indeterminate.writeIndeterminateArray, parentId)){
              indeterminate.writeIndeterminateArray.push(parentId);
            }
          }else{
            structureChild.writeChecked = false;
          }
          if(structureChild.children && structureChild.children.length){
            this.initReadWrite(structureChild.children, readCheckedProperties, writeCheckedProperties, indeterminate);
          }
        });
      },
      initIndeterminate(structure, readCheckedProperties, writeCheckedProperties){
        if(structure.children && structure.children.length){
          let readCheckedStatus = this.checkCheckedStatus(structure, readCheckedProperties);
          let writeCheckedStatus = this.checkCheckedStatus(structure, writeCheckedProperties);
          structure.readIndeterminate = !readCheckedStatus.allChecked && !readCheckedStatus.allNotChecked;
          structure.writeIndeterminate = !writeCheckedStatus.allChecked && !writeCheckedStatus.allNotChecked;
          structure.children.forEach( structureChild => {
            this.initIndeterminate(structureChild, readCheckedProperties, writeCheckedProperties)
          });
        }
      },
      checkCheckedStatus(structure, checkedProperties){
        let checkboxStatus = {
          allChecked: true,
          allNotChecked: true
        };
        structure.forEach( structureChild => {
          if(structureChild[checkedProperties]){
            checkboxStatus.allNotChecked = false;
          }else{
            checkboxStatus.allChecked = false;
          }
        });
        return checkboxStatus;
      },
      editFunction(node){
        this.$emit("editNode", node);
      },
      removeFunction(node){
        this.$emit("removeNode", node);
      },
      filterNode(value, data) {
        if (!value) return true;
        if (data[this.nodeName]) {
          return data[this.nodeName].indexOf(value) !== -1;
        }
      },
      nodeClick(data, node, myself){
        this.$emit("nodeClick", data, node);
      },
      addFunction(node){
        this.$emit("addNode", node);
      },
      allowDrop(draggingNode, dropNode, type) {
        if((type === 'prev' || type === 'next') && dropNode.data.name==='ROOT'){
          return false;
        }else{
          return true;
        }
      },
      allowDrag(draggingNode) {
        return true;
      },
      getStructure(){
        return this.structure;
      },
      getStructureExclusiveRoot(){
        return this.structure[0].children;
      },
      //表名最多只显示12个字符
      splitTableName(tableName){
        if(tableName && tableName.length > 100){
          return tableName.substring(0,100) + "...";
        }
        return tableName;
      },
      readChange(node){
        node.data.readIndeterminate = false;
        //先遍历子集的影响
        this.handleChildrenNodeLinkage(node, 'readChecked', 'readIndeterminate');
        //再遍历父集的影响
        this.handleParentNodeLinkage(node, 'readChecked', 'readIndeterminate');

        if(!node.readChecked){
          node.data.writeChecked = false;
          //先遍历子集的影响
          this.handleChildrenNodeLinkage(node, 'writeChecked', 'writeIndeterminate');
          //再遍历父集的影响
          this.handleParentNodeLinkage(node, 'writeChecked', 'writeIndeterminate');
        }
      },
      readChangeForIndependent(node){
        if(!node.readChecked) {
          node.data.writeChecked = false;
        }
      },
      handleChildrenNodeLinkage(node, checked, indeterminate){
        if(node.childNodes &&  node.childNodes.length){
          node.childNodes.forEach(nodeChild  => {
            nodeChild.data[checked] = node.data[checked];
            nodeChild.data[indeterminate] = false;
            this.handleChildrenNodeLinkage(nodeChild, checked, indeterminate);
          })
        }
      },
      handleParentNodeLinkage(node, checked, indeterminate){
        if (node.parent != null){
          let checkboxStatus = this.checkedChildNodeStatus(node.parent, checked, indeterminate);
          if(checkboxStatus.allChecked){
            node.parent.data[checked] = true;
            node.parent.data[indeterminate] = false
          }else if(checkboxStatus.allNotChecked){
            node.parent.data[checked] = false;
            node.parent.data[indeterminate] = false;
          }else{
            node.parent.data[indeterminate] = true;
          }
          this.handleParentNodeLinkage(node.parent, checked, indeterminate);
        }
      },
      checkedChildNodeStatus(node, checked, indeterminate){
        let checkboxStatus = {
          allChecked: true,
          allNotChecked: true
        };
        node.childNodes.forEach( childNode =>{
          if(childNode.data[checked]){
            checkboxStatus.allNotChecked = false;
          }else{
            checkboxStatus.allChecked = false;
          }
          if(childNode.data[indeterminate]){
            checkboxStatus.allNotChecked = false;
            checkboxStatus.allChecked = false;
          }
        });
        return checkboxStatus;
      },
      hasCheckedChildNode(node){

      },
      writeChange(node){
        node.data.writeIndeterminate = false;
        //先遍历子集的影响
        this.handleChildrenNodeLinkage(node, 'writeChecked', 'writeIndeterminate');
        //再遍历父集的影响
        this.handleParentNodeLinkage(node, 'writeChecked', 'writeIndeterminate');

        if(!node.writeChecked){
          node.data.readChecked = true;
          node.data.readIndeterminate = false;
          //先遍历子集的影响
          this.handleChildrenNodeLinkage(node, 'readChecked', 'readIndeterminate');
          //再遍历父集的影响
          this.handleParentNodeLinkage(node, 'readChecked', 'readIndeterminate');
        }

      },
      writeChangeForIndependent(node){
        if(!node.writeChecked) {
          node.data.readChecked = true;
        }
      },
      getCheckedNodesForReadWrite(isIncludeRoot){
        let checkedNodes = [];

        this.extractCheckNodes(isIncludeRoot ? this.structure : this.structure[0].children, checkedNodes);
        return checkedNodes;
      },
      extractCheckNodes(structure, checkedNodes){
        structure.forEach( structureChild => {
          if(structureChild.children && structureChild.children.length){
              this.extractCheckNodes(structureChild.children, checkedNodes);
          }
          if(structureChild.readChecked || structureChild.writeChecked){
            checkedNodes.push(structureChild);
          }
        })
      },
      inArray(arr, str) {
        let i = arr.length;
        while (i--) {
          if (arr[i] === str) {
            return true;
          }
        }
        return false;
      },
      filter(value){
        this.$refs.tree.filter(value);
      },
      getCheckedKeys(){
        return this.$refs.tree.getCheckedKeys();
      },
      setCheckedKeys(keys){
        this.$refs.tree.setCheckedKeys(keys);
      },
      setReadCheckboxKeys(keys, checked){
        if(keys && keys.length){
          keys.forEach( key =>{
             let node = this.$refs.tree.getNode(key);
             node.data.readChecked = checked;
             if(this.independent){
               this.readChangeForIndependent(node);
             }else{
               this.readChange(node);
             }
          });
        }
      },


      setWriteCheckboxKeys(keys, checked){
        if(keys && keys.length) {
          keys.forEach(key => {
            let node = this.$refs.tree.getNode(key);
            node.data.writeChecked = checked;
            if (this.independent) {
              this.writeChangeForIndependent(node);
            } else {
              this.writeChange(node);
            }
          });
        }
      },
      setReadCheckboxDisabledNodeKeys(keys){
        if(keys && keys.length){
          keys.forEach( key =>{
            let node = this.$refs.tree.getNode(key);
            node.data.writeDisabled = true;

          });
        }
      },
      setWriteCheckboxDisabledNodeKeys(keys){
        if(keys && keys.length){
          keys.forEach( key =>{
            let node = this.$refs.tree.getNode(key);
            node.data.writeDisabled = true;

          });
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    /deep/ .el-input {
      width: 220px !important;
    }

  }
  .black{
    color: black;
  }

  .cls-label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .el-button--mini, .el-button--mini.is-round {
    padding: 2px 2px;
  }


  /*.el-select {*/
  /*  width: auto !important;*/
  /*}*/

  /*.el-input {*/
  /*  width: auto !important;*/
  /*}*/
  /*.el-textarea{*/
  /*  width: auto !important;*/
  /*}*/

  .el-form-item__label {
    width: 112px;
    text-align: right !important;
  }
  .el-form--label-left /deep/ .el-form-item__label {
    width: 36%;
    text-align: right;
    font-size: 12px;
  }

  /*.el-input /deep/ .el-input__inner{*/
  /*  width: 250px;*/
  /*}*/

  /*.el-textarea /deep/ .el-textarea__inner{*/
  /*  width: 250px;*/
  /*}*/

  .el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content{
    background-color: #d7d6de;
  }
  .min-font{
    font-size: 12px;
  }

  /*/deep/ .el-textarea__inner{*/
  /*    padding: 5px 15px 10px 5px;*/
  /*}*/


  div /deep/ .el-tree-node__content {
    min-height: 32px !important;
  }

  div /deep/ .el-select__tags-text{
    display: inline-block;
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  div /deep/ .el-select .el-tag__close.el-icon-close{
    top: -6px;
  }
</style>

<style> 
  .cus-org-list-warp {
    max-height: 600px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/tree/tree_selection.vue